export class HTTPError extends Error {
  public name = 'HTTPError'
}
